import { format } from 'date-fns';
import { nl } from 'date-fns/locale';
import type { Locale } from 'date-fns';

export function formatEventDateRange(start: Date | string, end?: Date | string, locale: Locale = nl) {
  const startDate = new Date(start);
  const endDate = end ? new Date(end) : null;
  const dayPart = format(startDate, 'EEE d MMM yyyy', { locale });
  const timePart = endDate
    ? `${format(startDate, 'HH:mm', { locale })} - ${format(endDate, 'HH:mm', { locale })}`
    : `${format(startDate, 'HH:mm', { locale })}`;
  return `${dayPart}, ${timePart}`;
}

export function formatRangeNl(start: Date | string, end: Date | string) {
  return formatEventDateRange(start, end, nl);
}

export function getEventDisplayMeta(event: any) {
  const isNetworkingFilled =
    event?.eventType === 'networking_filled' ||
    event?.source === 'free_for_networking' ||
    event?.lockedToConnectionFlow;

  const meta = {
    title: event?.title || 'Afspraak',
    subtitle: '',
    badge: '',
    isNetworkingFilled,
    bgColor: event?.color || '#DBEAFE',
    borderColor: 'rgba(0,0,0,0.1)',
    textColor: '#1f2937', // gray-800
  };

  if (isNetworkingFilled) {
    meta.badge = 'Netwerken';
    meta.bgColor = '#EDE9FE'; // purple-100
    meta.borderColor = '#C4B5FD'; // purple-300
    meta.textColor = '#4C1D95'; // purple-900
  }

  return meta;
}

